import {Directive, ElementRef, EventEmitter, HostListener, Input, NgModule, Output} from '@angular/core';
import {CLICK_OUTSIDE_TRIGGER} from 'shared/magic';

@Directive({
	selector: '[libClickOutside]',
})

export class ClickOutsideDirective {
	@Output() clickOutside = new EventEmitter<string>();
	@Input() toggled = false;
	@Input() elementName: string;

	constructor(
		private elRef: ElementRef
	) {}

	@HostListener('document:click', ['$event.target'])
	onClick(target: HTMLElement) {
		const clickOutside = !(this.elRef.nativeElement as HTMLElement).contains(target);
		const toggleBtnClicked = target.classList.contains(CLICK_OUTSIDE_TRIGGER);
		if ((!this.toggled || toggleBtnClicked) || !clickOutside) return;
		this.clickOutside.emit(this.elementName);
	}
}
@NgModule({
	declarations: [ClickOutsideDirective],
	exports: [ClickOutsideDirective]
})
export class ClickOutsideDirectiveModule {}
